import { Tooltip, Typography, TypographyProps } from '@mui/material';
import { ReactNode } from 'react';

export const ClampedTypography = ({
  children,
  maxLines = 2,
  ...typographyProps
}: {
  children: ReactNode;
  maxLines?: number;
} & Partial<TypographyProps>) => {
  return (
    <Tooltip title={children} arrow>
      <Typography
        {...typographyProps}
        sx={{
          display: '-webkit-box',
          overflow: 'hidden',
          lineHeight: 'normal',
          textOverflow: 'ellipsis',
          WebkitLineClamp: maxLines,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};
